/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import List from 'rc-virtual-list'
import { Select } from 'antd'

const { Option } = Select

function classNames (...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function CustomSelect ({
  list,
  placeholder,
  name,
  onChange,
  value,
  defaultValue
}) {
  const [selected, setSelected] = useState(value || defaultValue || null)

  // Update internal state when value prop changes
  useEffect(() => {
    if (value !== undefined) {
      setSelected(value)
    }
  }, [value])

  // Update internal state when defaultValue prop changes and value is undefined
  useEffect(() => {
    if (value === undefined && defaultValue !== undefined) {
      setSelected(defaultValue)
    }
  }, [defaultValue, value])

  const onSearch = value => {
    console.log('search:', value)
  }

  // Safe filter function with null checks
  const filterOption = (input, option) => {
    try {
      if (!input || !option || !option.children) {
        return true
      }
      const searchText = input.toLowerCase()
      const optionText = option.children.toLowerCase()
      return optionText.includes(searchText)
    } catch (error) {
      console.error('Filter error:', error)
      return true
    }
  }

  // Safe onChange handler
  const handleChange = e => {
    try {
      setSelected(e)
      if (onChange && typeof onChange === 'function') {
        onChange(e)
      }
    } catch (error) {
      console.error('Change handler error:', error)
    }
  }

  return (
    <Select
      showSearch
      placeholder={placeholder}
      optionFilterProp='children'
      onChange={handleChange}
      onSearch={onSearch}
      value={selected}
      defaultValue={defaultValue}
      filterOption={filterOption}
      notFoundContent='No data found'
    >
      {list?.map(item => {
        // Handle different property names for display text
        const displayText =
          item.name ||
          item.modalName ||
          item.inches ||
          item.pcd ||
          item.holes ||
          item.finish ||
          item.width ||
          item.size ||
          item.id ||
          'Unknown'

        return (
          <Option value={item.id} key={item.id}>
            {displayText}
          </Option>
        )
      })}
    </Select>
    // <Listbox value={selected} onChange={setSelected}>
    //   {() => (
    //     <>
    //       <div className="mt-1 relative">
    //         <Listbox.Button
    //           onClick={() => setOpen(true)}
    //           className="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    //         >
    //           <span className="flex items-center h-5">
    //             <span className="block truncate">
    //               {selected.name || placeholder}
    //             </span>
    //           </span>
    //           <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
    //             <SelectorIcon
    //               className="h-5 w-5 text-gray-400"
    //               aria-hidden="true"
    //             />
    //           </span>
    //         </Listbox.Button>

    //         <Transition show={open} leaveFrom="opacity-100" leaveTo="opacity-0">
    //           <Listbox.Options
    //             onClick={() => setOpen(false)}
    //             className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
    //           >
    //             {/* {list?.map((person) => (

    //             ))} */}
    //             <List data={list} height={280} itemHeight={30} itemKey="id">
    //               {(person) => (
    //                 <Listbox
    //                   key={person?.id}
    //                   className={({ active }) =>
    //                     classNames(
    //                       active ? 'text-white bg-indigo-600' : 'text-gray-900',
    //                       'cursor-default select-none relative py-2 pl-3 pr-9'
    //                     )
    //                   }
    //                   value={person}
    //                 >
    //                   {({ selected, active }) => (
    //                     <>
    //                       <div
    //                         onClick={() => {
    //                           setSelected(person);
    //                           onChange(person.id);
    //                         }}
    //                         className="flex items-center h-5 cursor-pointer"
    //                       >
    //                         <span
    //                           className={classNames(
    //                             selected ? 'font-semibold' : 'font-normal',
    //                             'ml-3 block truncate'
    //                           )}
    //                         >
    //                           {person.name}
    //                         </span>
    //                       </div>

    //                       {selected ? (
    //                         <span
    //                           className={classNames(
    //                             active ? 'text-white' : 'text-indigo-600',
    //                             'absolute inset-y-0 right-0 flex items-center pr-4'
    //                           )}
    //                         >
    //                           <CheckIcon
    //                             className="h-5 w-5"
    //                             aria-hidden="true"
    //                           />
    //                         </span>
    //                       ) : null}
    //                     </>
    //                   )}
    //                 </Listbox>
    //               )}
    //             </List>
    //           </Listbox.Options>
    //         </Transition>
    //       </div>
    //     </>
    //   )}
    // </Listbox>
  )
}
